module.exports = __webpack_public_path__ + "img/usopp.a8ccad67.svg";